import axios from 'axios';
import authStore from "../Stores/AuthStore";
import errorStore from "../Stores/ErrorStore";
import pinCodeFormStore from "../Components/PinCodeForm/PinCodeFormStore";

axios.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response.status === 401) {
            authStore.logOut();
        }
        if (error.response.status === 403) {
            errorStore.add("У вас нет доступа для данной операции");
        }
        if (error.response.status === 400) {
            errorStore.add("Ошибка 400");
        }
        if (error.response.status === 502) {
            errorStore.add("Сервис не доступен :(");
        }
        return Promise.reject(error);
    }
);

let lastContextKey: string | undefined;

const api = {
    async post(url: string, data: any): Promise<any> {
        const result = await axios.post(`/api/${url}`, data, {
            headers: {Authorization: `Bearer ${authStore.token}`}
        });

        if (!result.data.success) {
            if (result.data.error === "EnterPinCode") {
                pinCodeFormStore.show();
            }
            else {
                errorStore.add(result.data.error);
            }
        }

        return result.data;
    },
    async get(url: string): Promise<any> {
        const result = await axios.get(`/api/${url}`, {
            headers: {Authorization: `Bearer ${authStore.token}`}
        });

        if (!result.data.success && result.data.error) {
            errorStore.add(result.data.error);
        }

        return result.data;
    },
    async auth(contextKey: string) {
        if (lastContextKey === contextKey) {
            return true;
        }

        const result = await api.post("user/auth", {contextKey: contextKey});
        if (result.success) {
            authStore.logIn(result.data.accessToken);
            lastContextKey = contextKey;
            return true;
        }

        return false;
    },
    authByToken(token: string) {
        authStore.logIn(token);
    }
}

export default api;